<template>
  <div class="login-container">
    <div class="login-box">
      <div class="logo-container">
        <img
          src="https://empleados.cargosprintgroup.com/static/img/logo/CargoSprint-Horizontal.svg"
          alt="CargoSprint"
          class="logo"
        />
      </div>

      <h2>Remittance Advice Portal</h2>
      <p class="subtitle">Finance Team Login</p>

      <form @submit.prevent="handleLogin" class="login-form">
        <div class="form-group">
          <label for="username">Username</label>
          <input
            type="text"
            id="username"
            v-model="username"
            placeholder="Enter your username"
            :disabled="loading"
            required
          />
        </div>

        <div class="form-group">
          <label for="password">Password</label>
          <input
            type="password"
            id="password"
            v-model="password"
            placeholder="Enter your password"
            :disabled="loading"
            required
          />
        </div>

        <div v-if="error" class="error-message">
          {{ error }}
        </div>

        <button type="submit" :disabled="loading || !username || !password">
          <span v-if="loading" class="loader-small"></span>
          <span v-else>Login</span>
        </button>
      </form>

      <div class="session-info">
        <p>Sessions available: {{ availableSessions }} / {{ maxSessions }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import authService from '@/services/auth';

export default {
  name: 'LoginPage',
  data() {
    return {
      username: '',
      password: '',
      loading: false,
      error: null,
      availableSessions: 4,
      maxSessions: 4
    };
  },
  async mounted() {
    await this.checkSessionStatus();
  },
  methods: {
    async checkSessionStatus() {
      try {
        const response = await fetch('/session/status');
        if (response.ok) {
          const data = await response.json();
          this.availableSessions = data.available_sessions;
          this.maxSessions = data.max_sessions;
        }
      } catch (err) {
        console.error('Failed to check session status:', err);
      }
    },

    async handleLogin() {
      this.loading = true;
      this.error = null;

      try {
        const data = await authService.login(this.username, this.password);

        this.$emit('login-success', data);
        this.$router.push({ name: 'ResultPage' });
      } catch (err) {
        console.error('Login error:', err);
        this.error = err.message || 'Unable to connect to server. Please try again.';
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background: linear-gradient(135deg, #14bb9c 0%, #0d8a73 100%);
}

.login-box {
  background: white;
  padding: 40px;
  border-radius: 4px;
  border: 6px solid #51bc9d;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  width: 100%;
  max-width: 28em;
}

.logo-container {
  text-align: center;
  margin-bottom: 24px;
}

.logo {
  height: 48px;
  width: auto;
}

.login-box h2 {
  margin: 0 0 8px 0;
  color: #5e5655;
  text-align: center;
  font-size: 20px;
  font-weight: 600;
}

.subtitle {
  color: #888;
  text-align: center;
  margin: 0 0 30px 0;
  font-size: 14px;
}

.login-form {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.form-group label {
  font-weight: 600;
  color: #5e5655;
  font-size: 14px;
}

.form-group input {
  padding: 12px 16px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
  transition: border-color 0.2s, box-shadow 0.2s;
  color: #5e5655;
}

.form-group input:focus {
  outline: none;
  border-color: #14bb9c;
  box-shadow: 0 0 0 2px rgba(20, 187, 156, 0.2);
}

.form-group input:disabled {
  background: #f5f5f5;
}

.form-group input::placeholder {
  color: #aaa;
}

.error-message {
  background: #fee;
  color: #c00;
  padding: 12px;
  border-radius: 4px;
  font-size: 14px;
  text-align: center;
}

button {
  padding: 12px 16px;
  background: #14bb9c;
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
}

button:hover:not(:disabled) {
  background: #20a78e;
}

button:disabled {
  background: #ccc;
  cursor: not-allowed;
}

.loader-small {
  width: 20px;
  height: 20px;
  border: 2px solid #fff;
  border-top: 2px solid transparent;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.session-info {
  margin-top: 24px;
  padding-top: 16px;
  border-top: 1px solid #eee;
  text-align: center;
  color: #888;
  font-size: 12px;
}

.session-info p {
  margin: 0;
}
</style>
